
import { isMobile, isMobileOnly } from 'mobile-device-detect';
import Vue from 'vue';
import BrowserAppBanner from '~/components/page-components/BrowserAppBanner.vue'
import BrowserExtensionBanner from '~/components/page-components/BrowserExtensionBanner.vue'
import { isPwaInstallable, isPwaStore } from '~/lib/accessors/store-accessor';

export default Vue.extend({
  components: {BrowserAppBanner, BrowserExtensionBanner},
  computed: {
    selected_component() {
      return isMobile ? BrowserAppBanner : BrowserExtensionBanner
    }
  }
})
